export default __webpack_public_path__ + "static/media/redux.addbb04a.png";